import { XA_FETCH_SUPPORTED_AGENT_VERSIONS_SUCCESS } from '../../actions/xAgent';

const INITIAL_STATE = {
  supported: {
    min: {
      version: '1.0.0',
    },
    deprecated: {
      version: '1.6.0',
    },
  },
  supportedForFlow: {
    min: {
      version: '1.4.1',
    },
    deprecated: {
      version: '1.0.0',
    },
  },
  supportedVersionsLoaded: false,
};

export default function xAgentSupportedVersionsReducer(
  state = INITIAL_STATE,
  action,
) {
  switch (action.type) {
    case XA_FETCH_SUPPORTED_AGENT_VERSIONS_SUCCESS:
      if (typeof action.payload.supported !== 'undefined') {
        return {
          ...state,
          supported: action.payload.supported.agent,
          supportedVersionsLoaded: true,
        };
      }
      return state;
    default: {
      return state;
    }
  }
}
